import useSWR, { useSWRConfig } from 'swr';

const useAuthenticated = (dataClient, swrOptions = {}) => {
    const swrConfig = useSWRConfig();
    dataClient.swrConfig = swrConfig;

    if (swrOptions.refreshInterval > 0) {
        dataClient.cacheExirationMs = swrOptions.refreshInterval;
    }

    const {data, error, isValidating, mutate} = useSWR('/identity/account/user', dataClient.fetcher, {
        onErrorRetry: (error, key, config, revalidate, { retryCount }) => {
          // Never retry on 404.
          if (error.status === 404) { return; }

          // Never retry on 403.
          if (error.status === 403) { return; }

          // Never retry on 401.
          if (error.status === 401) { return; }

          // Never retry for a specific key.
          if (key === '/identity/account/user')  { return; }

          // Only retry up to 3 times.
          if (retryCount >= 3) return

          // Retry after 5 seconds.
          setTimeout(() => revalidate({ retryCount }), 5000)
        }
      });

    const result = {
        result: data ? data : null,
        isAuthenticating: !error && !data,
        isAuthenticated: data !== undefined && data !== null && "id" in data,
        isError: !(!error),
        error: error,
        isValidating: isValidating,
        updateResult: mutate,
    }

    return result;
}

export {
    useAuthenticated
}